(function() {
    $(document).ready(function() {

        if ($('#js24MobilePhoneData').text().trim().length < 1) {
            $('.js24MobilePhone').hide();
        }

        if ($('.c24m-contact-text').text().trim().length < 1) {
            $('.c24m-contact-icon').hide();
        }

    });
})();
